import React from 'react';
import QueueAnim from 'rc-queue-anim';
import Button from '@mui/material/Button';
import { useIntl } from 'react-intl';

export interface NotFoundPageProps {
  onClick: () => void;
}

const NotFoundPage: React.FC<NotFoundPageProps> = ({ onClick }) => {
  const intl = useIntl();

  return (
    <section className={`container-fluid with-maxwidth page-dashboard chapter`}>
      <QueueAnim type="bottom" className="ui-animate">
        <div key="1">
          <section className="hero">
            <div className="hero-content">
              <h1 className="hero-title">
                {intl.formatMessage({ id: 'not.found.page.header' })}
              </h1>
            </div>
            <p className="hero-tagline">
              {intl.formatMessage({ id: 'not.found.page.message' })}
            </p>
            <div className="hero-action">
              <Button onClick={onClick} color="primary">
                {intl.formatMessage({ id: 'not.found.page.go.back' })}
              </Button>
            </div>
          </section>
        </div>
      </QueueAnim>
    </section>
  );
};

export default NotFoundPage;
